export const text3xl = '1.875rem';
export const text3xlLineHeight = '2.25rem';
export const text2xl = '1.5rem';
export const text2xlLineHeight = '2rem';
export const textSm = '0.875rem';
export const textSmLineHeight = '1.25rem';
export const textLg = '1.125rem';
export const textLgLineHeight = '1.75rem';
export const fontMedium = '500';
export const fontSemiBold = '600';
export const fontBold = '700';
export const gap2 = '0.5rem';
export const secondaryColor = '#18a8cb';
export const justifyContentSpaceBetween = 'space-between';

export const RGB_WHITE = [255, 255, 255];
export const RGB_SECONDARY_COLOR = [24, 168, 203];
export const RGB_PRIMARY_COLOR = [7, 38, 54];
